import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz'
import React, { useEffect, useState, useCallback } from "react";
import PageContainer from "../../../components/PageContainer";
import { useLocation } from 'react-router-dom';
import { MdOutlineArrowBack } from "react-icons/md";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import RelatorioApiService from "../../../services/api/RelatorioApiService";
import Loading from "../../../components/Loading";
import { Table, Dropdown, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import ConvertDataService from "../../../services/util/ConvertDatas";
import UtilService from "../../../services/util";
import { FiInfo } from "react-icons/fi";

const popupStyle = {
    position: 'absolute',
    top: '-250%',
    left: '-600%',
    transform: 'translateX(-80%)',
    backgroundColor: '#e9e9e9',
    color: '#212529',
    border: '1px solid #dee2e6',
    borderRadius: '5px',
    padding: '5px 10px',
    zIndex: 1000,
    whiteSpace: 'nowrap',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: 'auto',
    fontWeight: 'normal'
};

function RelatorioCapacidadeProjetoView() {
    const [loading, setLoading] = useState(false);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedRegime, setSelectedRegime] = useState('');
    const location = useLocation();
    const { data } = location.state || {};
    const history = useHistory();
    const [visiblePopup, setVisiblePopup] = useState(null);
    const [sortDirection, setSortDirection] = useState({});

    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [filteredProjetosColaboradores, setFilteredProjetosColaboradores] = useState([]);
    const [ordenacaoProjetosColaborador, setOrdenacaoProjetosColaborador] = useState([]);

    const dataInicialFiltro = ConvertDataService.convertDataSplitYYYYmmDD(data.periodoInicial);
    const dataFinalFiltro = ConvertDataService.convertDataSplitYYYYmmDD(data.periodoFinal);

    const fetchDadosRelatorio = useCallback(async () => {
        setLoading(true);
        try {
            const response = await RelatorioApiService.getRelatorioCapacidadeProjeto(
                dataInicialFiltro,
                dataFinalFiltro,
                data.projetosSelecionados
            );
            setDadosRelatorio(response.data.projetos);
        } catch (error) {
            console.error("Erro ao carregar dados do relatório:", error);
        } finally {
            setLoading(false);
        }
    }, [dataInicialFiltro, dataFinalFiltro, data.projetosSelecionados]);

    useEffect(() => {
        if (data && data.projetosSelecionados) {
            fetchDadosRelatorio();
        }
    }, [fetchDadosRelatorio]);

    useEffect(() => {
        const filtered = dadosRelatorio.map(item => {
            const { projeto, colaboradores } = item;

            const colabs = colaboradores.filter(colab => {
                const matchesDepartment = selectedDepartment
                    ? colab.colaborador.departamento?.toLowerCase() === selectedDepartment.toLowerCase()
                    : true;
                const matchesRegime = selectedRegime
                    ? colab.colaborador.regime?.toLowerCase() === selectedRegime.toLowerCase()
                    : true;
                return matchesDepartment && matchesRegime;
            });
            return { projeto: projeto, colaboradores: colabs };
        }); 
        setFilteredProjetosColaboradores(filtered);
    }, [selectedDepartment, selectedRegime, dadosRelatorio]);

    useEffect(() => {
        const filtered = filteredProjetosColaboradores.map(item => {
            const { projeto, colaboradores } = item;
            return {
                projeto: projeto, 
                colaboradores: colaboradores.sort((a, b) => a.colaborador.nome.localeCompare(b.colaborador.nome))
            };
        }); 
        setOrdenacaoProjetosColaborador(filtered);
    }, [filteredProjetosColaboradores]);

    const exportDataInExcel = async () => {
        const header = [
            [
                'Colaborador', "Projeto", "Categoria", 'Status', 'Departamento', 'Regime', 'Função', 'Perfil', 'Carga Horária Diária', 'Total Horas Obrigatórias', 'Total Horas Planejadas', 'Ocupação Planejada(%)', 'Total de Horas Realizadas', 'Ocupação Realizada (%)', 'Total de Horas Faturáveis', 'Ocupação Faturável (%)', 'Variação Faturável (%)'
            ]
        ];

        const formatedData = filteredProjetosColaboradores.map(item => {
            const colabs = item.colaboradores.map((colab) => {
                return {
                    colaborador: `${colab.colaborador.nome} ${colab.colaborador.sobrenome}`,
                    projeto: item.projeto.label,
                    categoria: item.projeto.categoria,
                    status: colab.colaborador.demissao ? "Inativo" : "Ativo",
                    departamento: colab.colaborador.departamento,
                    regime: colab.colaborador.regime,
                    funcao: colab.colaborador.funcao.nome,
                    perfil: `${colab.perfil}`,
                    cargaHorariaDiaria: Math.round(colab.horasPorDia),
                    totalHorasObrigatorias: `${Math.round(colab.totalHorasObrigatorias)}h`,
                    totalHorasPlanejadas: `${Math.round(colab.horasPlanejadas)}h`,
                    ocupacaoPlanejada: colab.colaborador.demissao ? "-- " : `${colab.ocupacao.ocupacaoPlanejada}%`,
                    totalHorasRealizadas: `${Math.round(colab.horasRealizadas)}h`,
                    ocupacaoRealizada: `${colab.ocupacao.ocupacaoRealizada}%`,
                    totalHorasFaturaveis: `${Math.round(colab.horasFaturaveis)}h`,
                    ocupacaoFaturavel: `${colab.ocupacao.ocupacaoFaturavel}%`,
                    variacaoFaturavel: colab.variacaoFaturavel
                };
            });
            return colabs;
        });

        UtilService.exportXls(formatedData.flat(), `Relatório Capacidade: ${data.periodoInicial} - ${data.periodoFinal}`, header);
    };

    const handleOrdenar = (key, project) => {
        let direction = sortDirection[key] || "cima";
        const filtered = filteredProjetosColaboradores.map(item => {
            const { projeto, colaboradores } = item;
            if (projeto.id === project.projeto.id) {
                const sortedColaboradores = [...colaboradores].sort((a, b) => {
                    if (key.includes("colaborador")) {
                        return direction.includes("cima") ? a.colaborador.nome.localeCompare(b.colaborador.nome) : b.colaborador.nome.localeCompare(a.colaborador.nome);
                    } else if (key.includes("departamento")) {
                        return direction.includes("cima") ? a.colaborador.departamento.localeCompare(b.colaborador.departamento) : b.colaborador.departamento.localeCompare(a.colaborador.departamento);
                    } else if (key.includes("regime")) {
                        return direction.includes("cima") ? (a.colaborador.regime || "").localeCompare(b.colaborador.regime || "") : (b.colaborador.regime || "").localeCompare(a.colaborador.regime || "");
                    } else if (key.includes("funcao")) {
                        return direction.includes("cima") ? a.colaborador.funcao.nome.localeCompare(b.colaborador.funcao.nome) : b.colaborador.funcao.nome.localeCompare(a.colaborador.funcao.nome);
                    } else if (key.includes("perfil")) {
                        return direction === "cima" ? a.perfil.localeCompare(b.perfil) : b.perfil.localeCompare(a.perfil);
                    } else if (key.includes("cargaHoraria")) {
                        return direction.includes("cima") ? a.horasPorDia - b.horasPorDia : b.horasPorDia - a.horasPorDia;
                    } else if (key.includes("ocupacaoPlanejada")) {
                        return direction.includes("cima") ? a.ocupacao.ocupacaoPlanejada - b.ocupacao.ocupacaoPlanejada : b.ocupacao.ocupacaoPlanejada - a.ocupacao.ocupacaoPlanejada;
                    } else if (key.includes("horasObrigatorias")) {
                        return direction.includes("cima") ? a.totalHorasObrigatorias - b.totalHorasObrigatorias : b.totalHorasObrigatorias - a.totalHorasObrigatorias;
                    } else if (key.includes("horasPlanejadas")) {
                        return direction.includes("cima") ? a.horasPlanejadas - b.horasPlanejadas : b.horasPlanejadas - a.horasPlanejadas;
                    } else if (key.includes("horasRealizadas")) {
                        return direction.includes("cima") ? a.horasRealizadas - b.horasRealizadas : b.horasRealizadas - a.horasRealizadas;
                    } else if (key.includes("ocupacaoRealizada")) {
                        return direction.includes("cima") ? a.ocupacao.ocupacaoRealizada - b.ocupacao.ocupacaoRealizada : b.ocupacao.ocupacaoRealizada - a.ocupacao.ocupacaoRealizada;
                    } else if (key.includes("horasFaturaveis")) {
                        return direction.includes("cima") ? a.horasFaturaveis - b.horasFaturaveis : b.horasFaturaveis - a.horasFaturaveis;
                    } else if (key.includes("ocupacaoFaturavel")) {
                        return direction.includes("cima") ? a.ocupacao.ocupacaoFaturavel - b.ocupacao.ocupacaoFaturavel : b.ocupacao.ocupacaoFaturavel - a.ocupacao.ocupacaoFaturavel;
                    } else if (key.includes("ocupacaoFaturavelProjeto")) {
                        return direction.includes("cima") ? a.ocupacao.ocupacaoFaturavelProjeto - b.ocupacao.ocupacaoFaturavelProjeto : b.ocupacao.ocupacaoFaturavelProjeto - a.ocupacao.ocupacaoFaturavelProjeto;
                    }
                    else if (key.includes("variacaoFaturavel")) {
                        return direction.includes("cima") ? a.variacaoFaturavel - b.variacaoFaturavel : b.variacaoFaturavel - a.variacaoFaturavel;
                    }
                    return 0;
                });
                return { projeto: projeto, colaboradores: sortedColaboradores };
            }
            return { projeto: projeto, colaboradores: colaboradores };
        }); 

        direction = direction.includes("cima") ? "baixo" : "cima";
        setSortDirection({ ...sortDirection, [key]: direction });
    
        setOrdenacaoProjetosColaborador(filtered);
    };

    const SortIcon = ({ column, sortDirection }) => {
        if (!sortDirection[column]) {
            return <FaSort className="ml-1" style={{ opacity: 0.3 }} />;
        }
        return sortDirection[column].includes("cima") ? 
            <FaSortUp className="ml-1" /> : 
            <FaSortDown className="ml-1" />;
    };

    const totalHorasPlanejadasProjetos = (project) => {
        return project.colaboradores.reduce((total, item) => {
            return total + item.horasPlanejadas;
        }, 0);
    };

    const totalHorasObrigatoriasProjetos = (project) => {
        return project.colaboradores.reduce((total, item) => {
            return total + item.totalHorasObrigatorias;
        }, 0);
    };

    const totalHorasRealizadasProjetos = (project) => {
        return project.colaboradores.reduce((total, item) => {
            return total + item.horasRealizadas;
        }, 0);
    };

    const totalHorasFaturaveisProjetos = (project) => {
        return project.colaboradores.reduce((total, item) => {
            return total + item.horasFaturaveis;
        }, 0);
    };

    // Sempre calcular totais localmente para refletir os filtros aplicados
    const calcularTotaisGerais = () => {
        return ordenacaoProjetosColaborador.reduce((totais, proj) => {
            const totalHorasObrigatorias = totalHorasObrigatoriasProjetos(proj);
            const totalHorasPlanejadas = totalHorasPlanejadasProjetos(proj);
            const totalHorasRealizadas = totalHorasRealizadasProjetos(proj);
            const totalHorasFaturaveis = totalHorasFaturaveisProjetos(proj);
    
            return {
                totalHorasObrigatorias: totais.totalHorasObrigatorias + totalHorasObrigatorias,
                totalHorasPlanejadas: totais.totalHorasPlanejadas + totalHorasPlanejadas,
                totalHorasRealizadas: totais.totalHorasRealizadas + totalHorasRealizadas,
                totalHorasFaturaveis: totais.totalHorasFaturaveis + totalHorasFaturaveis,
            };
        }, {
            totalHorasObrigatorias: 0,
            totalHorasPlanejadas: 0,
            totalHorasRealizadas: 0,
            totalHorasFaturaveis: 0,
        });
    };

    const totaisGerais = calcularTotaisGerais();
    const totalOcupacaoFaturavelGeral = totaisGerais.totalHorasPlanejadas > 0
        ? Math.round((totaisGerais.totalHorasFaturaveis * 100) / totaisGerais.totalHorasPlanejadas)
        : 0;

    const riscoDemissao = {
        textDecoration: "line-through"
    };

    const handleCancel = () => {
        history.push('../relatorios-delivery/');
    };

    const actions = [
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: handleCancel
        }
    ];

    const fixarTitulo = {
        "position": "sticky", 
        "top": 0, 
        "zIndex": 9998, 
        "backgroundColor": "#f5f5f5",
    };

    const fixarThead = { 
        position: "sticky", 
        top: 0, 
        zIndex: 1000, 
        backgroundColor: "#f5f5f5", 
        "boxShadow": " 0 4px 4px -4px rgba(0, 0, 0, 0.3)" 
    };

    const handleMouseEnter = (popupId) => {
        setVisiblePopup(popupId);
    };

    const handleMouseLeave = () => {
        setVisiblePopup(null);
    };

    return (
        <>
        <div style={fixarTitulo}>
            <PageContainer title={"Relatório Capacidade por Projeto"} actions={actions}>
                <h5>Período Inicial: {data.periodoInicial}</h5>
                <h5 className="mb-4">Período Final: {data.periodoFinal}</h5>
                {data.radioValue === "cliente" && <h5 className="mb-4">Cliente: {data.cliente}</h5>}
                
                <div className="d-flex" style={{position: "sticky"}}>
                <Button onClick={() => exportDataInExcel()} className='mr-3'>Exportar</Button>
                <Dropdown className="mr-3">
                    <Dropdown.Toggle variant="light" id="dd-column">
                        Filtrar por Departamento: <span style={{ fontWeight: 'bold' }}>{selectedDepartment ? selectedDepartment : "Todos"}</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setSelectedDepartment('Delivery')}>
                            Delivery
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setSelectedDepartment('ENGESOL')}>
                            ENGESOL
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setSelectedDepartment('Overhead')}>
                            Overhead
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setSelectedDepartment('')}>
                            Todos
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

                <Dropdown>
                    <Dropdown.Toggle variant="light" id="dd-column">
                        Filtrar por Regime: <span style={{ fontWeight: 'bold' }}>{selectedRegime ? selectedRegime : "Todos"}</span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setSelectedRegime('CLT')}>
                            CLT
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setSelectedRegime('Estagiário')}>
                            Estagiário
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setSelectedRegime('')}>
                            Todos
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                </div>
            </PageContainer>
            </div>
                {loading ? <Loading message={"Carregando..."} /> : 
                (ordenacaoProjetosColaborador.length > 0 && !loading ? (
                    <div>
                        <Table striped bordered hover style={{background: "#e1eaf3"}}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Total horas obrigatorias</th>
                                    <th>Total horas Planejadas</th>
                                    <th>Total horas Realizadas</th>
                                    <th>Total horas Faturáveis</th>
                                    <th>Total Ocupação Faturável (%)</th>
                                    <th>Total Ocupação <br/> Faturável nos Projetos (%)</th>
                                </tr>
                                
                            </thead>
                            <tbody>
                                <tr style={{background: "transparent"}}>
                                    <td><strong>Total</strong></td>
                                    <td><strong>{Math.round(totaisGerais.totalHorasObrigatorias)}h</strong></td> 
                                    <td><strong>{Math.round(totaisGerais.totalHorasPlanejadas)}h</strong></td>
                                    <td><strong>{Math.round(totaisGerais.totalHorasRealizadas)}h</strong></td>
                                    <td><strong>{Math.round(totaisGerais.totalHorasFaturaveis)}h</strong></td>
                                    <td><strong>{Math.round((totaisGerais.totalHorasFaturaveis * 100) / totaisGerais.totalHorasObrigatorias) || 0}%</strong></td>
                                    <td><strong>{totalOcupacaoFaturavelGeral}%</strong></td>
                                </tr>
                            </tbody>
                        </Table>
                        {ordenacaoProjetosColaborador.map((proj) => {
                            return <div key={proj.projeto.id} id="tabela-personalizada-relatorio-capacidade" style={{maxHeight: "calc(100vh - 220px)", overflowY: "auto"}}>
                            <h5 className='mt-3'><strong>Projeto:</strong> {proj.projeto.label}</h5>
                            <h5 className="mb-4"><strong>Categoria:</strong> {proj.projeto.categoria}</h5>
                            <Table striped bordered hover responsive="xl">
                            <thead style={fixarThead}>
                                <tr>
                                <th className="fixed-column no-wrap" onClick={() => handleOrdenar(`colaborador-${proj.projeto.id}`, proj)}>Colaborador <SortIcon column={`colaborador-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar(`departamento-${proj.projeto.id}`, proj)}>Departamento <SortIcon column={`departamento-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar(`regime-${proj.projeto.id}`, proj)}>Regime do contrato <SortIcon column={`regime-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar(`funcao-${proj.projeto.id}`, proj)}>Função <SortIcon column={`funcao-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar(`perfil-${proj.projeto.id}`, proj)}>Perfil <SortIcon column={`perfil-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar(`cargaHoraria-${proj.projeto.id}`, proj)}>Cargas horárias <br/> diárias <SortIcon column={`cargaHoraria-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar(`horasObrigatorias-${proj.projeto.id}`, proj)}>Total horas <br/> Obrigatórias <SortIcon column={`horasObrigatorias-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap verde-claro-planejado" onClick={() => handleOrdenar(`horasPlanejadas-${proj.projeto.id}`, proj)}>Total horas <br/> Planejadas <SortIcon column={`horasPlanejadas-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap verde-claro-planejado" onClick={() => handleOrdenar(`ocupacaoPlanejada-${proj.projeto.id}`, proj)}>Ocupação <br/> Planejada (%) <SortIcon column={`ocupacaoPlanejada-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar(`horasRealizadas-${proj.projeto.id}`, proj)}>Total horas <br/> Realizadas <SortIcon column={`horasRealizadas-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar(`ocupacaoRealizada-${proj.projeto.id}`, proj)}>Ocupação <br/> Realizada (%) <SortIcon column={`ocupacaoRealizada-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar(`horasFaturaveis-${proj.projeto.id}`, proj)}>Total horas <br/> Faturáveis <SortIcon column={`horasFaturaveis-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar(`ocupacaoFaturavel-${proj.projeto.id}`, proj)}>Ocupação <br/> Faturável (%) <SortIcon column={`ocupacaoFaturavel-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar(`ocupacaoFaturavelProjeto-${proj.projeto.id}`, proj)}>Ocupação <br/> Faturável <br/> no Projeto (%) <SortIcon column={`ocupacaoFaturavelProjeto-${proj.projeto.id}`} sortDirection={sortDirection} /></th>
                                <th className="no-wrap cinza-claro-variacao" onClick={() => handleOrdenar(`variacaoFaturavel-${proj.projeto.id}`, proj)}>Variação <br/> Faturável (%)
                                    <span 
                                    onMouseEnter={() => handleMouseEnter('variacao_faturavel')}
                                    onMouseLeave={handleMouseLeave}
                                    className="ml-1 info-icon"
                                    style={{ position: 'relative', cursor: 'pointer'}}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'variacao_faturavel' && (
                                            <div className="hover-popup" style={popupStyle}> 
                                                Diferença entre total de horas planejadas e o total de horas faturáveis.
                                            </div>
                                        )}
                                    </span>
                                    <SortIcon column={`variacaoFaturavel-${proj.projeto.id}`} sortDirection={sortDirection} />
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                {proj.colaboradores
                                .map((item, index) => {
                                    return (
                                    <tr key={index}>
                                    <td className="fixed-column no-wrap" style={item.colaborador.demissao ? riscoDemissao : {}}>{item.colaborador.nome} {item.colaborador.sobrenome} </td>
                                    <td className="no-wrap">{item.colaborador.departamento}</td>
                                    <td className="no-wrap">{item.colaborador.regime || "N/A"}</td>
                                    <td className="no-wrap">{item.colaborador.funcao.nome}</td>
                                    <td className="no-wrap">{item.perfil}</td>
                                    <td className="no-wrap">{Math.round(item.horasPorDia)}h</td>
                                    <td className="no-wrap">{Math.round(item.totalHorasObrigatorias)}h</td>
                                    <td className="no-wrap verde-claro-planejado">{Math.round(item.horasPlanejadas)}h</td>
                                    <td className="no-wrap verde-claro-planejado">{item.colaborador.demissao ? "-- " : item.ocupacao.ocupacaoPlanejada}%</td>
                                    <td className="no-wrap azul-claro-realizado">{Math.round(item.horasRealizadas)}h</td>
                                    <td className="no-wrap azul-claro-realizado">{item.ocupacao.ocupacaoRealizada}%</td>
                                    <td className="no-wrap azul-claro-realizado">{Math.round(item.horasFaturaveis)}h</td>
                                    <td className="no-wrap azul-claro-realizado">{item.ocupacao.ocupacaoFaturavel}%</td>
                                    <td className="no-wrap azul-claro-realizado">{item.horasPlanejadas > 0 ? Math.round((item.horasFaturaveis * 100) / item.horasPlanejadas) || 0 : 0}%</td>
                                    <td className="no-wrap cinza-claro-variacao">{item.variacaoFaturavel}%</td>
                                    </tr>
                                    );
                                })}
                                <tr>
                                <td className="fixed-column no-wrap"><strong>Total de colaboradores: {proj.colaboradores.length}</strong></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="no-wrap"><strong>{Math.round(totalHorasObrigatoriasProjetos(proj))}h</strong></td>
                                <td className="no-wrap verde-claro-planejado"><strong>{Math.round(totalHorasPlanejadasProjetos(proj))}h</strong></td>
                                <td className="no-wrap verde-claro-planejado"><strong>{Math.round((totalHorasPlanejadasProjetos(proj) * 100) / totalHorasObrigatoriasProjetos(proj)) || 0}%</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{Math.round(totalHorasRealizadasProjetos(proj))}h</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{Math.round((totalHorasRealizadasProjetos(proj) * 100) / totalHorasObrigatoriasProjetos(proj)) || 0}%</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{Math.round(totalHorasFaturaveisProjetos(proj))}h</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{Math.round((totalHorasFaturaveisProjetos(proj) * 100) / totalHorasObrigatoriasProjetos(proj)) || 0}%</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{Math.round((totalHorasFaturaveisProjetos(proj) * 100) / totalHorasPlanejadasProjetos(proj)) || 0}%</strong></td>
                                <td className="no-wrap cinza-claro-variacao">
                                    <strong>
                                        {(() => {
                                            const totalPlanejadas = totalHorasPlanejadasProjetos(proj);
                                            const totalFaturaveis = totalHorasFaturaveisProjetos(proj);
                                            const desvio = totalPlanejadas === 0
                                                ? (totalFaturaveis === 0 ? 0 : -100)
                                                : ((totalPlanejadas - totalFaturaveis) / totalPlanejadas) * 100;
                                            return `${Math.round(desvio)}%`;
                                        })()}
                                    </strong>
                                </td>
                                </tr>
                            </tbody>
                            </Table>
                        </div>;
                    })}
                </div>
                ) : <div>Nenhum colaborador encontrado.</div>)
                }
        </>
    );
}

export default RelatorioCapacidadeProjetoView;
